import React from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import { UserLocation, UserPhoto, UserArchetype } from "components/User";
import { ProfileAssignedIcon, ProfileFlag, ProfileLink } from "components/Profile";
import { Col, Row } from "components/Containers";
import Tags, { TAG_SIZE } from "components/Tags";
import { TAG_COLORS } from "components/Tags/Tag";
import { resolveCapacityStatusColor } from "utils";

/**
 * ColumnMember
 *
 * @param {Object}  data
 * @param {Boolean} showArchetype
 * @param {Boolean} showLocation
 * @param {Boolean} showDisciplines
 * @param {Boolean} showProfileFlag
 * @param {Boolean} showHighlights
 * @param {Boolean} showProfileAssigned
 */
const ColumnMember = ({
  data,
  showArchetype = false,
  showLocation = true,
  showDisciplines = false,
  showHighlights = false,
  showProfileFlag = false,
  showProfileAssigned,
  ...props
}) => (
  <Row noWrap css={styles.container}>
    <UserPhoto
      data={data?.profile}
      width="5rem"
      height="5rem"
      statusColor={resolveCapacityStatusColor(data?.profile?.capacityStatus)}
    />
    <Col gap="0.5rem">
      <span>
        <div css={styles.profileLinkContainer}>
          <ProfileLink profile={data?.profile} withOverlay {...props} />
          {showProfileFlag && (
            <span css={styles.profileIcon}>
              <ProfileFlag count={data?.profile?.flaggedCommentsCount} hideFlagCount />
            </span>
          )}
          {showProfileAssigned && (
            <span css={styles.profileIcon}>
              <ProfileAssignedIcon isAssigned={data?.profileData?.isAssigned} />
            </span>
          )}
        </div>
        {showArchetype && (
          <div>
            <UserArchetype data={data?.profileData} />
          </div>
        )}
      </span>
      {showLocation && <UserLocation data={data?.profile} />}
      {showDisciplines && (
        <Row>
          <Tags
            size={TAG_SIZE.small}
            data={data?.profileData?.disciplines?.map((discipline) => ({ name: discipline }))}
            {...TAG_COLORS.purple}
            limit={2}
          />
        </Row>
      )}
      {showHighlights && (
        <Row>
          <Tags
            size={TAG_SIZE.small}
            {...TAG_COLORS.green}
            data={data?.highlights?.map((highlight) => ({ name: highlight.name }))}
            limit={2}
          />
        </Row>
      )}
    </Col>
  </Row>
);

const styles = {
  container: css`
    padding: 0.5rem 0;
  `,
  profileLinkContainer: css`
    display: flex;
    align-items: anchor-center;
  `,
  profileIcon: css`
    margin-left: 0.5rem;
  `,
};

ColumnMember.propTypes = {
  data: PropTypes.object.isRequired,
  showArchetype: PropTypes.bool,
  showLocation: PropTypes.bool,
  showDisciplines: PropTypes.bool,
  showProfileFlag: PropTypes.bool,
  showHighlights: PropTypes.bool,
  showProfileAssigned: PropTypes.bool,
};

export default ColumnMember;
